export const VET_DOMAINS_ICON_SRC = "/vetdomains.png";
export const VET_DOMAINS_ICON_CLASS = "h-5 w-5 object-contain flex-shrink-0 mt-0.5";

const VET_DOMAINS_SUBTITLES = {
  vet_domains_registration: "Domain Registration",
  vet_domains_renewal: "Domain Renewal",
  vet_domains_payment_refund: "Payment Refund",
  vet_domains_registration_commitment: "Registration Commitment",
  vet_domains_wrap: "Wrap",
  vet_domains_unwrap: "Unwrap",
  vet_domains_resolver_update: "Resolver Update",
  vet_domains_primary_name_update: "Primary Name Update",
};

function normalizeVetDomainsClassification(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_")
    .replace(/_+/g, "_");
}

function looksLikeVetDomainsApp(value) {
  const raw = String(value || "").trim().toLowerCase();
  return (
    raw === "vet.domains" ||
    raw === "vetdomains" ||
    raw.includes("vet.domains") ||
    raw.includes("vetdomains")
  );
}

export function isVetDomainsClass(classification) {
  const cls = normalizeVetDomainsClassification(classification);
  return cls.startsWith("vet_domains_") || cls.startsWith("vetdomains_");
}

export function isVetDomainsTransaction(tx = {}, classification = "") {
  const cls = normalizeVetDomainsClassification(
    classification || tx?.classification || tx?.type
  );
  if (isVetDomainsClass(cls) || VET_DOMAINS_SUBTITLES[cls]) return true;

  if (tx?.partOfVetDomains === true) return true;

  if (
    looksLikeVetDomainsApp(tx?.application) ||
    looksLikeVetDomainsApp(tx?.sourcePlatform) ||
    looksLikeVetDomainsApp(tx?.protocol)
  ) {
    return true;
  }

  const semantic = String(
    tx?.providerSemanticType || tx?.protocolClassification || ""
  )
    .trim()
    .toLowerCase();
  if (
    semantic.startsWith("vet_domains_") ||
    semantic.startsWith("vetdomains_") ||
    semantic === "vns_points_distribution"
  ) {
    return true;
  }

  if (String(tx?.domainName || tx?.domainLabel || "").trim()) return true;

  const nftName = String(tx?.nftName || tx?.nft_name || tx?.name || "")
    .trim()
    .toLowerCase();
  if (nftName.endsWith(".vet")) return true;

  return false;
}

export function getVetDomainsDisplay(classification, tx = null) {
  const cls = normalizeVetDomainsClassification(
    classification || tx?.classification || tx?.type
  );
  const domainName = String(
    tx?.domainName || tx?.domainLabel || tx?.nftName || tx?.nft_name || ""
  ).trim();

  if (VET_DOMAINS_SUBTITLES[cls]) {
    return {
      title: "vet.domains",
      subtitle: domainName
        ? `${VET_DOMAINS_SUBTITLES[cls]} · ${domainName}`
        : VET_DOMAINS_SUBTITLES[cls],
    };
  }

  if (cls === "airdrop" && tx && isVetDomainsTransaction(tx, cls)) {
    const isExplicitNonIncome =
      tx?.excludeFromTaxIncome === true ||
      (tx?.taxable === false &&
        String(tx?.taxTreatment || "").trim().toLowerCase() ===
          "non_income_airdrop");
    return {
      title: "vet.domains",
      subtitle: isExplicitNonIncome
        ? "VNS Points Airdrop"
        : "VNS Points Airdrop",
    };
  }

  if (tx && isVetDomainsTransaction(tx, cls)) {
    const fallback = cls.startsWith("vet_domains_")
      ? cls
          .replace(/^vet_domains_/, "")
          .split("_")
          .filter(Boolean)
          .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
          .join(" ")
      : "";

    return {
      title: "vet.domains",
      subtitle:
        (domainName && fallback ? `${fallback} · ${domainName}` : null) ||
        domainName ||
        fallback ||
        String(tx.subApplication || "").trim() ||
        "Domain Activity",
    };
  }

  return null;
}
